<template>
  <div>
    <div class="yuliang" ref="yuliang">
      <div class="select">
        <span class="before" @click="beforeday(n, m)">前一天</span>
        <span class="desc">日期:</span>
        <div class="block" style="display: inline-block;">
          <el-date-picker
            v-model="selehour"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            @change="selectdate"
          ></el-date-picker>
        </div>
        <span class="next" @click="nextday(n, m)">后一天</span>
        <span @click="exportdata" id="export">
          <span class="export-icon"></span>导出
        </span>
      </div>
      <div class="raintable">
         <ux-grid
          v-loading="loading"
          ref="plTable"
          :max-height="height"
          border
          style="width: 100%;"
          :sort-config="{defaultSort:{field: 'accRain_Str',order: 'desc'}}"
          :row-style="OverRain"
        >
          <ux-table-column
            fixed= "left"
            type="index"
            width="50"
            title="序号"
            align="center"
            header-align="center"
          >
          </ux-table-column>
          <ux-table-column
           fixed= "left"
            field="addvnm"
            title="乡镇"
            min-width="110"
            header-align="center"
            sortable
          ></ux-table-column>
          <ux-table-column
            fixed= "left"
            field="stnm"
            title="站点"
            min-width="140"
            align="center"
            header-align="center"
            sortable
          >
            <template slot-scope="scope">
              <el-tooltip effect="dark" :content="scope.row.stnm + ' ' + (scope.row.stcd?scope.row.stcd:'')" placement="top" class="item" popper-class="hiddenOverflow">
                <span style="cursor:pointer!important;" >{{ scope.row.stationName }}</span>
              </el-tooltip>
            </template>
          </ux-table-column>
          <ux-table-column
            fixed= "left"
            title="累计"
            field="accRain_Str"
            width="75"
            align="center"
            header-align="center"
            sortable
            :sort-method="sortByAccRain"
          >
            <template slot-scope="scope">
              {{formatTableCellValue(scope.row.accRain_Str)}}
            </template>
          </ux-table-column>
          <ux-table-column title="时段" header-align="center">
            <ux-table-column
              min-width="61"
              v-for="(item,index) in thedate"
              :key="index"
              :field="item"
              :title="item"
              sortable
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <!-- <span>{{formatTableCellValue(scope.row['old'+item])}}</span> -->
                <span v-if="scope.row[item] >=30" style="color:red;font-weight:bold">{{scope.row[item]}}</span>
                <span v-else>{{scope.row[item]===-1?'-':scope.row[item]}}</span>
              </template>
            </ux-table-column>
          </ux-table-column>
        </ux-grid>
      </div>
    </div>
    <el-dialog :title="thestation" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <div id="station"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import monitorTypes from '@/store/types/monitor'
export default {
  name: 'MonitoringCenter',
  data () {
    return {
      loading: true,
      height: 10,
      sID: '22',
      sTID: '',
      beginDate: '',
      endDate: '',
      stationName: '',
      isTown: true,
      searchName: '',
      tdata: [],
      all: true,
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 100,
      towns: [],
      checkarr: [],
      datenum: '',
      thedate: [
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08'
      ],
      selehour: '',
      n: 0,
      m: -1,
      dialogVisible: false,
      thestation: ''
    }
  },
  computed: {},
  methods: {
    sortByAccRain (a, b) {
      if (a.accRain_Str !== undefined) {
        return a.accRain_Str - b.accRain_Str
      } else {
        return -1
      }
    },
    OverRain ({ row, rowIndwx }) {
      // let myStyle = {}
      // for (let i = 0; i < this.thedate.length; i++) {
      //   if (row[this.thedate[i]] >= 30) {
      //     myStyle = { 'background': '#FE5555' }
      //     break
      //   }
      // }
      // return myStyle
    },
    stationchart (data) {
      this.thestation = data
      this.dialogVisible = true
    },
    tabledata () {
      this.loading = true
      this.$store
        .dispatch(monitorTypes.GET_HOURLY_RAINFALL_INFO, {
          sID: this.sID,
          sTID: this.sTID,
          beginTime: this.beginDate,
          endTime: this.endDate,
          mainStation: true
        })
        .then(data => {
          this.tdata = data.rows
          this.tdata.forEach(item => {
            item.data.forEach(element => {
              let date = element.date.slice(11)
              item[date] = element.value_Str ? element.value : -1 // 解决排序问题
              // item[date] = this.getTableCellValue(element.value_Str)
              // item['old' + date] = element.value_Str
            })
          })
          this.$refs.plTable.reloadData(this.tdata)
          this.loading = false
        })
    },
    getTableCellValue: function (val) {
      let result = 0
      if (val !== undefined && val !== '') {
        result = Number(val)
      }
      return result
    },
    formatTableCellValue (val) {
      let result = val
      if (val === undefined || val === '') {
        result = '-'
      }
      return result
    },
    getdate: function (n, m, day) {
      // 昨天的时间
      // 今天的时间
      let day1 = new Date()
      let day2 = new Date()
      if (day !== undefined) {
        day1 = new Date(day.replace(/-/, '/'))
        day2 = new Date(day.replace(/-/, '/'))
      }
      day1.setTime(day1.getTime() - n * 24 * 60 * 60 * 1000)
      day2.setTime(day2.getTime() - m * 24 * 60 * 60 * 1000)
      this.beginDate =
        day1.getFullYear() +
        '-' +
        (day1.getMonth() + 1) +
        '-' +
        (day1.getDate()) +
        ' 09:00'
      let modelval =
        day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
      this.selehour = modelval
      this.endDate =
        day2.getFullYear() +
        '-' +
        (day2.getMonth() + 1) +
        '-' +
        (day2.getDate()) +
        ' 08:00'
    },
    selectdate: function () {
      let daytime = new Date(this.selehour.replace(/-/, '/'))
      this.loading = true
      if (this.selehour !== '' && this.selehour !== null) {
        this.beginDate = this.selehour + ' ' + '09:00'
        daytime.setDate(daytime.getDate() + 1)
        var y = daytime.getFullYear()
        var m =
          daytime.getMonth() + 1 < 10
            ? '0' + (daytime.getMonth() + 1)
            : daytime.getMonth() + 1
        var d =
          daytime.getDate() < 10 ? '0' + daytime.getDate() : daytime.getDate()
        this.endDate = y + '-' + m + '-' + d + ' ' + '08:00'
      } else {
        this.getdate()
      }
      this.tabledata()
    },
    beforeday: function () {
      this.n = 1
      this.m = 0
      this.getdate(this.n, this.m, this.selehour)
      this.tabledata()
    },
    nextday: function () {
      this.n = -1
      this.m = -2
      this.getdate(this.n, this.m, this.selehour)
      this.tabledata()
    },
    exportdata () {
      this.$store
        .dispatch(monitorTypes.EXPORT_RAINSTATIS_HOURLY, {
          sID: this.sID,
          sTID: this.sTID,
          beginTime: this.beginDate,
          endTime: this.endDate,
          mainStation: true
        })
        .then(data => {
          window.location.href = this.Global.basePath + data.data
        })
    }
  },
  filters: {
    rounding (num) {
      var result = parseFloat(num)
      if (isNaN(result)) {
        return '-'
      } else if (result === 0) {
        return num
      }
      result = Math.round(num * 100) / 100
      var value = result.toString() // 将数字转换为字符串
      let posdecimal = value.indexOf('.') // 小数点的索引值
      // 当整数时，posdecimal=-1 自动补0
      if (posdecimal < 0) {
        posdecimal = value.length
        value += '.'
      }
      // 当数字的长度< 小数点索引+2时，补0
      while (value.length <= posdecimal + 1) {
        value += '0'
      }
      return value
    }
  },
  mounted () {
    let date = new Date()
    if (date.getHours() <= 8) { // 显示前一天数据
      this.n = 1
      this.m = 0
    }
    this.getdate(this.n, this.m)
    this.tabledata()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height =
        contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45 + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height =
        this.$refs['yuliang'].offsetHeight - selectDiv[0].offsetHeight - 20
    })
  }
}
</script>
<style lang="less" scoped>
  .raintable{
      margin-top: 5Px;
      width:98%;
      margin-left: 1%;
    }
  /* 样式穿透 */
 .plTableBox /deep/ .elx-table{
  text-align: center !important;
  font-family: Microsoft YaHei UI !important;
  font-size: 15px !important;
  color: #666 !important;
  .elx-table--header-wrapper {
    background: #eaf1fa;
  }
}
.raintable /deep/ .elx-table tr:nth-child(even) {
  background: #eaf1fa !important;
}
</style>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style scoped>
.yuliang >>> .el-date-editor.el-input,
.yuliang >>> .el-date-editor.el-input__inner {
  width: 150px;
}
#station {
  width: 500px;
  height: 300px;
}
</style>
